module.exports = __webpack_public_path__ + "static/media/all-allowed-alloy-svgrepo-com.93280290.svg";